// import postSvg from "@/static/imgs/post.svg"
import postDetailSvg from '@/static/imgs/postDetail.svg';
import { message } from 'antd';

type Group = {
  is_private: boolean;
  is_user_joined: boolean;
  logo: string;
  member_count: number;
  post_count: number;
  title: string;
  uid: string;
  user_has_pending_application: boolean;
  bg: string;
};

type GroupDetailpageControlButtonProps = {
  type: 'post' | 'create' | 'activity';
  title: string;
  group: Group;
  isAuthenticated: boolean;
};

const PostBtn = (props: { title: string }) => {
  return (
    <div className="cursor-pointer py-18px rounded-6px h-76px bg-hex-fff flex justify-center items-center">
      <img className="mr-8px h-18px w-18px" src={postDetailSvg} />
      <span className="text-hex-000">{props.title}</span>
    </div>
  );
};
const GroupDetailpageControlButton: React.FC<
  GroupDetailpageControlButtonProps
> = (props) => {
  return (
    <>
      {props.group.is_user_joined ? (
        <a
          href={`/group/new-post/?group_uid=${props.group.uid}`}
          className="cursor-pointer py-18px rounded-6px h-76px bg-hex-fff flex justify-center items-center"
          target="_blank"
          rel="noreferrer"
        >
          <img className="mr-8px h-18px w-18px" src={postDetailSvg} />
          <span className="text-hex-000">{props.title}</span>
        </a>
      ) : (
        <div
          onClick={() => {
            const msg = props.isAuthenticated
              ? message.error('请先加入本圈子')
              : message.error('请登录后访问');
            return msg;
          }}
        >
          <PostBtn title={props.title} />
        </div>
      )}
    </>
  );
};

export default GroupDetailpageControlButton;
